export const FAIRPATH_PROCESS_STEPS = [
  {
    number: "01",
    title: "Identify the property and sources",
    description:
      "Start with an address or assessment notice. FairPath identifies the property, assessment authority, available official records, and any facts that still need confirmation.",
  },
  {
    number: "02",
    title: "Review the evidence record",
    description:
      "Review sourced property facts and comparable evidence, then add corrections, documents, photos, and condition details that public records cannot show.",
  },
  {
    number: "03",
    title: "Decide, download, and file",
    description:
      "Inspect the evidence plan before purchase. If you continue, download the packet and follow the verified local process for your own filing.",
  },
] as const;

export const FAIRPATH_PROCESS_SUMMARY = FAIRPATH_PROCESS_STEPS
  .map((step, index) => `${index + 1}. ${step.description}`)
  .join(" ");
